module.exports = __webpack_public_path__ + "static/media/Helpdesk.1eab3ea5.svg";